import React, { useState, useEffect } from 'react';
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';
import { adminAPI } from '../services/api';

const AdminFeedback = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('pending'); // pending, approved, all

  useEffect(() => {
    loadFeedback();
  }, []);

  const loadFeedback = async () => {
    try {
      const response = await adminAPI.getFeedback();
      setFeedbacks(response.data.feedback || []);
    } catch (error) {
      console.error('Error loading feedback:', error);
    } finally {
      setLoading(false);
    }
  };

  const approveFeedback = async (feedbackId) => {
    try {
      await adminAPI.approveFeedback(feedbackId);
      loadFeedback();
      alert('Feedback approved successfully');
    } catch (error) {
      alert('Error approving feedback');
    }
  };

  const deleteFeedback = async (feedbackId) => {
    if (!window.confirm('Are you sure you want to delete this feedback?')) return;

    try {
      await adminAPI.deleteFeedback(feedbackId);
      loadFeedback();
      alert('Feedback deleted successfully');
    } catch (error) {
      alert('Error deleting feedback');
    }
  };

  const filteredFeedbacks = feedbacks.filter(fb => {
    if (filter === 'pending') return !fb.is_approved;
    if (filter === 'approved') return fb.is_approved;
    return true; // all
  });

  return (
    <div>
      <Header />
      <main>
        <section className="section">
          <h1 style={{ color: 'var(--maroon)', fontFamily: "'Playfair Display',serif", marginBottom: '20px' }}>
            Feedback Management
          </h1>

          {/* Filter Tabs */}
          <div className="card" style={{ marginBottom: '20px', padding: '12px', display: 'flex', gap: '10px' }}>
            <button
              onClick={() => setFilter('pending')}
              style={{
                padding: '8px 16px',
                borderRadius: '6px',
                border: 'none',
                background: filter === 'pending' ? 'var(--maroon)' : 'var(--glass)',
                color: filter === 'pending' ? '#fff' : 'var(--text)',
                cursor: 'pointer',
                fontWeight: '600'
              }}
            >
              Pending ({feedbacks.filter(f => !f.is_approved).length})
            </button>
            <button
              onClick={() => setFilter('approved')}
              style={{
                padding: '8px 16px',
                borderRadius: '6px',
                border: 'none',
                background: filter === 'approved' ? 'var(--maroon)' : 'var(--glass)',
                color: filter === 'approved' ? '#fff' : 'var(--text)',
                cursor: 'pointer',
                fontWeight: '600'
              }}
            >
              Approved ({feedbacks.filter(f => f.is_approved).length})
            </button>
            <button
              onClick={() => setFilter('all')}
              style={{
                padding: '8px 16px',
                borderRadius: '6px',
                border: 'none',
                background: filter === 'all' ? 'var(--maroon)' : 'var(--glass)',
                color: filter === 'all' ? '#fff' : 'var(--text)',
                cursor: 'pointer',
                fontWeight: '600'
              }}
            >
              All ({feedbacks.length})
            </button>
          </div>

          {/* Feedback List */}
          {loading ? (
            <div style={{ textAlign: 'center', padding: '50px', color: 'var(--muted)' }}>
              Loading feedback...
            </div>
          ) : (
            <div style={{ display: 'grid', gap: '16px' }}>
              {filteredFeedbacks.map((feedback) => (
                <div key={feedback.feedback_id} className="card" style={{ padding: '20px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
                    <div>
                      <h3 style={{ margin: '0 0 4px 0', color: 'var(--maroon)' }}>
                        {feedback.full_name || feedback.username}
                      </h3>
                      <p style={{ margin: '0', color: 'var(--muted)', fontSize: '14px' }}>
                        {feedback.email} {feedback.phone && `• ${feedback.phone}`}
                      </p>
                      <p style={{ margin: '4px 0 0 0', color: 'var(--muted)', fontSize: '12px' }}>
                        {new Date(feedback.created_at).toLocaleString()}
                      </p>
                    </div>
                    <div>
                      <span style={{
                        padding: '4px 8px',
                        borderRadius: '6px',
                        background: feedback.is_approved ? 'rgba(5,150,105,0.1)' : 'rgba(234,179,8,0.1)',
                        color: feedback.is_approved ? '#059669' : '#eab308',
                        fontSize: '12px',
                        fontWeight: '600'
                      }}>
                        {feedback.is_approved ? 'APPROVED' : 'PENDING'}
                      </span>
                    </div>
                  </div>

                  <div style={{ 
                    padding: '16px', 
                    background: 'rgba(0,0,0,0.02)', 
                    borderRadius: '8px', 
                    marginBottom: '16px',
                    borderLeft: '4px solid var(--maroon)'
                  }}>
                    <p style={{ margin: '0', lineHeight: '1.6' }}>{feedback.feedback_text}</p>
                  </div>

                  <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                    {!feedback.is_approved && (
                      <button
                        onClick={() => approveFeedback(feedback.feedback_id)}
                        style={{
                          padding: '8px 16px',
                          borderRadius: '6px',
                          border: 'none',
                          background: '#059669',
                          color: '#fff',
                          cursor: 'pointer',
                          fontWeight: '600'
                        }}
                      >
                        Approve
                      </button>
                    )}
                    <button
                      onClick={() => deleteFeedback(feedback.feedback_id)}
                      style={{
                        padding: '8px 16px',
                        borderRadius: '6px',
                        border: 'none',
                        background: '#dc2626',
                        color: '#fff',
                        cursor: 'pointer',
                        fontWeight: '600'
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}

          {filteredFeedbacks.length === 0 && !loading && (
            <div style={{ textAlign: 'center', padding: '50px', color: 'var(--muted)' }}>
              No feedback found for the selected filter.
            </div>
          )}
        </section>

        <Footer />
      </main>
    </div>
  );
};

export default AdminFeedback;
